import React from 'react';
import DatePicker from 'react-datepicker';
import CalendarHeader from './CalendarHeader';
import CalendarInput from './CalendarInput';
import { CalendarContainer } from './CalendarPicker.styles';

export interface CalendarPickerInterface {
  popperPlacement?:
    | 'top'
    | 'right'
    | 'bottom'
    | 'left'
    | 'top-end'
    | 'top-start'
    | 'right-end'
    | 'right-start'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start';
  selectedDate?: Date | null;
  onChange?: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  width?: string | number;
  disabled?: boolean;
  /** Optional `data-name` set on the underlying input, for test selectors. */
  dataName?: string;
}

/**
 * CalendarPicker component part of the design system. Replaces native date input for consistency across browsers.
 * @param popperPlacement - Preferred popper placement; adjusts to the opposite side if there's insufficient space.
 */
const CalendarPicker = ({
  popperPlacement = 'bottom',
  selectedDate,
  onChange,
  minDate,
  maxDate,
  width,
  disabled,
  dataName,
}: CalendarPickerInterface) => {
  return (
    <CalendarContainer width={width}>
      <DatePicker
        selected={selectedDate}
        showPopperArrow={false}
        onChange={onChange && onChange}
        popperPlacement={popperPlacement}
        renderCustomHeader={CalendarHeader}
        customInput={
          <CalendarInput
            className="calendar-picker-input"
            dataName={dataName}
          />
        }
        enableTabLoop={false}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
    </CalendarContainer>
  );
};

export default CalendarPicker;
